import { useTranslation } from 'react-i18next';
import { Typography, styled, useTheme, Container } from '@mui/material';
import React, { useContext } from 'react';
import { CASHBACK_WIZARD_START } from '../../src/helpers/urlConstants';
import { Header } from '../../components/Header/Header';
import { Fund } from '../../api/useFunds';
import { CashbackCalculatorContext } from '../../components/CashbackCalculatorProvider';
import { useGoogleTagManager } from '../../src/hooks/useGoogleTagManager';
import { USER_FLOW_ID } from '../../src/helpers/constants';
import { DetailCalculatorWithUrlChange } from './DetailCalculatorWithUrlChange';

const CalculatorBox = styled('div')(({ theme }) => ({
  border: 'solid 1px',
  borderRadius: '8px',
  borderColor: theme.palette.border.secondary,

  [theme.breakpoints.down('sm')]: {
    boxShadow: '0px 2px 4px -1px rgba(30, 39, 50, 0.16)',
  },
}));

export interface Props {
  changeUrl?: boolean;
}

export const CashbackCalculator = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const ref = useContext(CashbackCalculatorContext);

  const sendToGoogleTagManager = useGoogleTagManager(USER_FLOW_ID);

  const onFundSelect = (selectedFund: Fund) => {
    if (!ref?.current?.fundsMap?.some((fund: Fund) => fund.isin === selectedFund.isin)) {
      sendToGoogleTagManager({
        contextId: 'cashback-calculator',
        event: 'fund-selected',
        contentElementId: selectedFund.isin,
      });
    }
  };

  return (
    <Container
      data-sectionid="cashback-calculator"
      sx={{
        padding: theme.spacing(10, 0),
        [theme.breakpoints.down('md')]: {
          padding: theme.spacing(10, 3),
        },
      }}
    >
      <Header
        variant="h1"
        headerText={t('cashbackCalculator.title')}
        id="detail-calculator"
        align="center"
        sx={{ marginBottom: theme.spacing(4) }}
      />
      <Typography variant="subtitle2" color="textSecondary" align="center">
        {t('cashbackCalculator.subheading')}
      </Typography>
      <Typography
        variant="subtitle2"
        color="textSecondary"
        align="center"
        sx={{ marginBottom: theme.spacing(10) }}
      >
        {t('cashbackCalculator.goodToKnow')}
      </Typography>
      <CalculatorBox>
        <DetailCalculatorWithUrlChange
          bookNowUrl={CASHBACK_WIZARD_START}
          calculatorRef={ref}
          onFundSelect={onFundSelect}
        />
      </CalculatorBox>
    </Container>
  );
};
